<script>
import { mapGetters } from 'vuex'
import UserEditForm from '../../components/UserEditForm.vue'

export default {
    name: 'AccountProfile',
    components: { UserEditForm },
    computed: {
        ...mapGetters(['userResource'])
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Profil</h4>
            <p class="text-muted mb-0">Verwalten Sie Ihre persönlichen Informationen und Rennfahrerdetails.</p>
        </div>
        <b-card>
            <user-edit-form :user-resource="userResource" submit-text="Profil speichern" success-message="Profil gespeichert!" />
        </b-card>
    </div>
</template>
